import { Component, EventEmitter, Output } from '@angular/core';
import { MessageAction } from '@app/models/message-action.model';
import { COMPONENT_NAME, EVENT_TYPE } from '@app/constants/message.constants';
import { MessageComponent } from '@app/models/message-base.component';

@Component({
  selector: 'helpful-information',
  templateUrl: './helpful-information.component.html',
  styleUrls: ['./helpful-information.component.scss']
})

export class HelpfulInformationComponent extends MessageComponent {
  @Output() onMessageAction = new EventEmitter<MessageAction>();
  override type = COMPONENT_NAME.HELPFUL_INFORMATION;

  onSatisfiedClick() {
    this.enabledButtons = false;
    this.onMessageAction.emit({ type: EVENT_TYPE.SATISFACTION_VALUE, value: true });
  }
  onUnsatisfiedClick() {
    this.enabledButtons = false;
    this.onMessageAction.emit({ type: EVENT_TYPE.SATISFACTION_VALUE, value: false });
  }
}
